// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-bell-item {
  display: flex;
  align-items: center;
  margin-right: 4px;
}
.notification-bell-item .notification-bell-btn {
  color: #666;
  padding: 8px;
}
.notification-bell-item .notification-bell-btn:hover {
  background: rgba(26, 29, 79, 0.08);
}

.notifications-drawer .notifications-drawer-paper {
  width: 420px;
  max-width: 100vw;
  height: 100%;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
}

.notifications-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.notifications-drawer-title {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #1a1d4f;
}

.notifications-drawer-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
}

.mark-all-read-btn {
  border: 0;
  background: none;
  color: #1a1d4f;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}
.mark-all-read-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.notifications-filter {
  min-width: 120px;
}
.notifications-filter .MuiOutlinedInput-root {
  border-radius: 8px;
}
.notifications-filter .MuiOutlinedInput-notchedOutline {
  border-color: #7c4dff;
}

.notifications-drawer-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.expiry-summary {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.expiry-summary-title {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #1a1d4f;
}

.expiry-summary-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  gap: 10px;
}

.notifications-empty {
  text-align: center;
  color: #888;
  padding: 24px 12px;
}

.notification-card {
  position: relative;
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) 88px;
  grid-template-rows: auto auto;
  align-items: center;
  grid-gap: 6px 12px;
  gap: 6px 12px;
  min-height: 88px;
  padding: 14px 18px 14px 14px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  overflow: hidden;
}
.notification-card--read {
  opacity: 0.85;
}

.notification-card-icon {
  grid-row: 1/span 2;
  grid-column: 1;
  align-self: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-card-content {
  grid-column: 2;
  grid-row: 1/span 2;
  align-self: center;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding-right: 4px;
}

.notification-card-title {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #222;
  line-height: 1.35 !important;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.notification-card-message {
  font-size: 12px !important;
  color: #666;
  line-height: 1.45 !important;
  min-height: 17px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.notification-card-checkbox {
  grid-column: 3;
  grid-row: 1;
  align-self: start;
  justify-self: end;
  padding: 0 !important;
  margin: -4px -4px 0 0 !important;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.notification-card:hover .notification-card-checkbox {
  opacity: 1;
}

.notification-card-date {
  grid-column: 3;
  grid-row: 2;
  align-self: end;
  justify-self: end;
  font-size: 11px !important;
  color: #888;
  line-height: 1.2 !important;
  white-space: nowrap;
  min-height: 14px;
}

.notification-card-accent {
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  height: 100%;
}

.notifications-drawer-footer {
  padding: 16px;
  display: flex;
  justify-content: center;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

@media (max-width: 600px) {
  .notifications-drawer .notifications-drawer-paper {
    width: 100vw;
  }
  .notifications-drawer-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .notifications-drawer-actions {
    width: 100%;
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Header/NotificationsDrawer.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;AACJ;AACI;EACE,kCAAA;AACN;;AAKE;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,4CAAA;AAHF;;AAMA;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;AAHF;;AAMA;EACE,eAAA;EACA,yBAAA;AAHF;;AAMA;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,0BAAA;AAHF;AAKE;EACE,YAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,gBAAA;AAJF;AAME;EACE,kBAAA;AAJJ;AAOE;EACE,qBAAA;AALJ;;AASA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;EACA,4CAAA;AANF;;AASA;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EAAA,SAAA;AANF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AANF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,+CAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EAAA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,qCAAA;EACA,sBAAA;EACA,gBAAA;AANF;AAQE;EACE,aAAA;AANJ;;AAUA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;AAPF;;AAUA;EACE,0BAAA;EACA,2BAAA;EACA,WAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,sBAAA;AAPF;;AAUA;EACE,0BAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,sBAAA;AAPF;;AAUA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gCAAA;EACA,UAAA;EACA,6BAAA;AAPF;;AAUA;EACE,UAAA;AAPF;;AAUA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;AAPF;;AAUA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,yCAAA;AAPF;;AAUA;EAEI;IACE,YAAA;EARJ;EAYA;IACE,sBAAA;IACA,uBAAA;EAVF;EAaA;IACE,WAAA;IACA,8BAAA;EAXF;AACF","sourcesContent":[".notification-bell-item {\n  display: flex;\n  align-items: center;\n  margin-right: 4px;\n\n  .notification-bell-btn {\n    color: #666;\n    padding: 8px;\n\n    &:hover {\n      background: rgba(26, 29, 79, 0.08);\n    }\n  }\n}\n\n.notifications-drawer {\n  .notifications-drawer-paper {\n    width: 420px;\n    max-width: 100vw;\n    height: 100%;\n    max-height: 100vh;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.notifications-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.notifications-drawer-title {\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  color: #1a1d4f;\n}\n\n.notifications-drawer-actions {\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.mark-all-read-btn {\n  border: 0;\n  background: none;\n  color: #1a1d4f;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: underline;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.notifications-filter {\n  min-width: 120px;\n\n  .MuiOutlinedInput-root {\n    border-radius: 8px;\n  }\n\n  .MuiOutlinedInput-notchedOutline {\n    border-color: #7c4dff;\n  }\n}\n\n.notifications-drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.expiry-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.expiry-summary-title {\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  color: #1a1d4f;\n}\n\n.expiry-summary-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.notifications-empty {\n  text-align: center;\n  color: #888;\n  padding: 24px 12px;\n}\n\n.notification-card {\n  position: relative;\n  display: grid;\n  grid-template-columns: 40px minmax(0, 1fr) 88px;\n  grid-template-rows: auto auto;\n  align-items: center;\n  gap: 6px 12px;\n  min-height: 88px;\n  padding: 14px 18px 14px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  overflow: hidden;\n\n  &--read {\n    opacity: 0.85;\n  }\n}\n\n.notification-card-icon {\n  grid-row: 1 / span 2;\n  grid-column: 1;\n  align-self: center;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notification-card-content {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  align-self: center;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  padding-right: 4px;\n}\n\n.notification-card-title {\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  color: #222;\n  line-height: 1.35 !important;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.notification-card-message {\n  font-size: 12px !important;\n  color: #666;\n  line-height: 1.45 !important;\n  min-height: 17px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.notification-card-checkbox {\n  grid-column: 3;\n  grid-row: 1;\n  align-self: start;\n  justify-self: end;\n  padding: 0 !important;\n  margin: -4px -4px 0 0 !important;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.notification-card:hover .notification-card-checkbox {\n  opacity: 1;\n}\n\n.notification-card-date {\n  grid-column: 3;\n  grid-row: 2;\n  align-self: end;\n  justify-self: end;\n  font-size: 11px !important;\n  color: #888;\n  line-height: 1.2 !important;\n  white-space: nowrap;\n  min-height: 14px;\n}\n\n.notification-card-accent {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 5px;\n  height: 100%;\n}\n\n.notifications-drawer-footer {\n  padding: 16px;\n  display: flex;\n  justify-content: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n@media (max-width: 600px) {\n  .notifications-drawer {\n    .notifications-drawer-paper {\n      width: 100vw;\n    }\n  }\n\n  .notifications-drawer-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .notifications-drawer-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
